/**
 * Marketing mirror of the cabinet catalog (apps/shell/src/catalog.ts).
 * Kept as a standalone copy on purpose — the marketing SPA must not pull
 * the shell workspace (and its whole build graph) in as a dependency just
 * to list titles. When a cartridge lands in the shell catalog, add its
 * card here too. Ordered newest-first, matching the gallery's front row.
 */
export interface GameCard {
  id: string;
  title: string;
  blurb: string;
  genre: string;
  accent: string;
  accent2: string;
}

export const GAMES: readonly GameCard[] = [
  {
    id: 'neon-grind',
    title: 'NEON GRIND',
    blurb: 'Open neon skatepark, 2:00 on the clock. Airs, spins, and rail grinds — string the combo, bank the seconds.',
    genre: 'SKATE',
    accent: '#c8ff3d',
    accent2: '#ff3d9a',
  },
  {
    id: 'neon-rapids',
    title: 'NEON RAPIDS',
    blurb: 'Fly the neon river. Shoot the fleet, refuel over depots, never touch the walls.',
    genre: 'SHOOTER',
    accent: '#29e6ff',
    accent2: '#27e060',
  },
  {
    id: 'turbo-moto',
    title: 'TURBO MOTO 84',
    blurb: 'Endless dirt-track motocross. Hop lanes, stomp landings, ride the redline.',
    genre: 'RACING',
    accent: '#ff8030',
    accent2: '#ff3030',
  },
  {
    id: 'neon-apex',
    title: 'NEON APEX',
    blurb: 'Open-world BMX, 2:00 on the clock. Tricks and coins buy seconds — spend them flying.',
    genre: 'BMX',
    accent: '#29e6ff',
    accent2: '#ff3d9a',
  },
  {
    id: 'stray-pixel',
    title: 'STRAY PIXEL',
    blurb: 'The dot that never stopped bouncing. Chase the perfect corner.',
    genre: 'ZEN',
    accent: '#ffea00',
    accent2: '#29e6ff',
  },
  {
    id: 'deep-core',
    title: 'DEEP CORE',
    blurb: 'Dig the neon strata, pump the blobs, respect the boulders.',
    genre: 'DIGGER',
    accent: '#ff00aa',
    accent2: '#ff8a3c',
  },
  {
    id: 'cube-jump',
    title: 'CUBE JUMP',
    blurb: 'Paint the pyramid. Dodge the springers. Do not look down.',
    genre: 'HOPPER',
    accent: '#ffd23d',
    accent2: '#7a3cff',
  },
  {
    id: 'defense-grid',
    title: 'DEFENSE GRID',
    blurb: 'Six cities, three silos, ten waves of magenta rain.',
    genre: 'DEFENSE',
    accent: '#ff3d9a',
    accent2: '#29e6ff',
  },
  {
    id: 'bunker-84',
    title: 'BUNKER-84',
    blurb: 'First-person infiltration. 35 sectors down, and it gets worse every 5.',
    genre: 'FPS',
    accent: '#ff5050',
    accent2: '#7a3cff',
  },
  {
    id: 'jade-tunnel',
    title: 'JADE TUNNEL',
    blurb: 'Race the sinking sun through the jungle to the idol vault.',
    genre: 'ADVENTURE',
    accent: '#27e060',
    accent2: '#ffd23d',
  },
  {
    id: 'cargo-climb',
    title: 'CARGO CLIMB',
    blurb: 'Ride the crates up the construction site. Mind your head.',
    genre: 'PLATFORM',
    accent: '#ffd23d',
    accent2: '#ff8a3c',
  },
  {
    id: 'neon-overpass',
    title: 'NEON OVERPASS',
    blurb: 'Full-3D circuit racing on an elevated highway over the bay.',
    genre: 'RACING',
    accent: '#ff3d9a',
    accent2: '#7a3cff',
  },
  {
    id: 'astrofall',
    title: 'ASTROFALL',
    blurb: 'Wireframe rocks, four shells, and a hyperspace you must earn.',
    genre: 'SHOOTER',
    accent: '#29e6ff',
    accent2: '#7a3cff',
  },
  {
    id: 'interceptor',
    title: 'INTERCEPTOR',
    blurb: 'Night highway pursuit. The Switchblade lunges when you blink.',
    genre: 'PURSUIT',
    accent: '#29e6ff',
    accent2: '#ff5050',
  },
  {
    id: 'stardust',
    title: 'STARDUST',
    blurb: 'One ship, one life, and an ammo economy written in shards.',
    genre: 'SHOOTER',
    accent: '#7a3cff',
    accent2: '#ffd23d',
  },
  {
    id: 'city-hop',
    title: 'CITY HOP',
    blurb: 'Eight-way hops through traffic, trains, and the river fog.',
    genre: 'CROSSING',
    accent: '#27e060',
    accent2: '#29e6ff',
  },
  {
    id: 'maze-patrol',
    title: 'MAZE PATROL',
    blurb: 'Tag the thieves before the maze itself rotates under you.',
    genre: 'MAZE',
    accent: '#ffd23d',
    accent2: '#29e6ff',
  },
  {
    id: 'trench-run',
    title: 'TRENCH RUN',
    blurb: 'Haul civilians out of the neon canyon. Payload slows you down.',
    genre: 'RESCUE',
    accent: '#29e6ff',
    accent2: '#ff3d9a',
  },
  {
    id: 'sector-seven',
    title: 'SECTOR SEVEN',
    blurb: 'Hold the rim of the tube. Dive when you dare — triple damage.',
    genre: 'TUBE',
    accent: '#7a3cff',
    accent2: '#29e6ff',
  },
  {
    id: 'pirate-fleet',
    title: 'PIRATE FLEET',
    blurb: 'Open-sea broadsides, buried gold, and a boss on the horizon.',
    genre: 'NAVAL',
    accent: '#ffd23d',
    accent2: '#ff3d9a',
  },
];
